import React from 'react'

export default function IconAnalytics({
  size = '1em',
  style = {},
  fill = 'currentColor',
  ...rest
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      style={style}
      fill={fill}
      viewBox="0 0 50 50"
      {...rest}
    >
      <path
        fill={fill}
        fillRule="evenodd"
        d="M34.333 8.333v1.334h5.042L31 18.042l-2.188-2.188-.479-.458-.479.458-7.52 7.521-2.188-2.188-.48-.458-.479.459-8.666 8.666.958.959 8.188-8.188 2.187 2.188.48.458.479-.459 7.52-7.52 2.188 2.187.479.459.48-.459 8.853-8.854v5.042h1.334V8.333h-7.334zm2 9.334v24h1.334v-24h-1.334zm4 .666v23.334h1.334V18.333h-1.334zm-12 3.334v20h1.334v-20h-1.334zm4 0v20h1.334v-20h-1.334zm-8 2.666v17.334h1.334V24.333h-1.334zm-8 2.667v14.667h1.334V27h-1.334zm4 1.333v13.334h1.334V28.333h-1.334zm-8 2.667v10.667h1.334V31h-1.334zm-4 2.667v8h1.334v-8H8.333z"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}
